/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerFindAllQueryResponse,
  TelegramChatsUserControllerFindAllQueryParams,
  TelegramChatsUserControllerFindAll401,
} from '../types/TelegramChatsUserControllerFindAll.ts';

function getTelegramChatsUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/chats` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats}
 */
export async function telegramChatsUserFindAll(
  params?: TelegramChatsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramChatsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramChatsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramChatsUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
